import { supabase } from "@/integrations/supabase/client";

type BoardType = "prebuilt" | "custom" | "ai_generated";
type CreationStep =
  | "workspace_fetch"
  | "board_create"
  | "personas_create"
  | "project_create"
  | "session_create";

interface LogAttemptParams {
  userId: string;
  boardType: BoardType;
  step: CreationStep;
  status: "success" | "failure";
  errorMessage?: string;
  errorCode?: string;
  boardId?: string;
  templateBoardId?: string;
}

export const logBoardCreationAttempt = async (params: LogAttemptParams) => {
  try {
    const { error } = await supabase.from("board_creation_attempts").insert({
      user_id: params.userId,
      board_type: params.boardType,
      step: params.step,
      status: params.status,
      error_message: params.errorMessage,
      error_code: params.errorCode,
      board_id: params.boardId,
      template_board_id: params.templateBoardId,
    });

    if (error) {
      console.error("Failed to log board creation attempt:", error);
    }
  } catch (error) {
    // Silent fail - logging shouldn't break the user flow
    console.error("Error in logBoardCreationAttempt:", error);
  }
};

// Helper function to determine error code from error object
export const getErrorCode = (error: any): string => {
  if (error?.code) return error.code;
  if (error?.status) return `HTTP_${error.status}`;
  return "UNKNOWN_ERROR";
};

// Helper function to extract meaningful error message
export const getErrorMessage = (error: any): string => {
  if (typeof error === "string") return error;
  if (error?.message) return error.message;
  if (error?.error_description) return error.error_description;
  return "An unknown error occurred";
};
